import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = {
  key: 0,
  class: "section"
}
const _hoisted_3 = {
  key: 1,
  class: "report-chart"
}
const _hoisted_4 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AVBChart = _resolveComponent("AVBChart")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        (_ctx.filters.avb)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "section-title" }, [
                _createElementVNode("div", { class: "section-badge" }),
                _createTextVNode(" Actual vs Benchmark IRR ")
              ], -1),
              _createElementVNode("div", { class: "section-content" }, " The dispersion of Actual vs. Benchmark IRR can be seen below. The size of the bubbles in the chart indicates the population of savers while the position represents their Actual and Benchmark IRRs. The green bubbles indicate an average AgeWage score above 50 outperforming the benchmark on average, while red bubbles have scores below 50 underperforming the benchmark. The chart can not only help understand the performance of the majority of savers but also help to identify outliers who have significantly out/under-performed. ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingChartData && _ctx.filters.avb)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.avbData)
                ? (_openBlock(), _createBlock(_component_AVBChart, {
                    key: 0,
                    chartData: _ctx.avbData,
                    plotterColor: _ctx.plotterColor
                  }, null, 8, ["chartData", "plotterColor"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}